import { render } from "./inviteUserDialog.vue?vue&type=template&id=98d881be&scoped=true"
import script from "./inviteUserDialog.vue?vue&type=script&lang=js"
export * from "./inviteUserDialog.vue?vue&type=script&lang=js"

import "./inviteUserDialog.vue?vue&type=style&index=0&id=98d881be&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d881be"]])

export default __exports__